import {
  archiveSuccessPlanTemplate,
  createSuccessPlanTemplate,
  fetchAllSuccessPlanTemplates,
  fetchSuccessPlanTemplateById,
  updateSuccessPlanTemplate,
} from '../../routines/successplanTemplates/successPlanTemplates';

const initialState = {
  selectedSuccessPlanTemplate: null,
  selectedSuccessPlanTemplateLoading: false,
  selectedSuccessPlanTemplateSuccess: true,
  successPlanTemplateList: [],
  successPlanTemplateListLoading: false,
  successPlanTemplateListSuccess: false,
  successPlanTemplateCreating: false,
  successPlanTemplateCreateSuccess: false,
  successPlanTemplateUpdating: false,
  successPlanTemplateUpdateSuccess: false,
  successPlanTemplateArchiving: false,
  successPlanTemplateArchiveSuccess: false,
};

const successPlanTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchAllSuccessPlanTemplates.TRIGGER:
      return {
        ...state,
        successPlanTemplateCreateSuccess: false,
        successPlanTemplateListLoading: true,
      };
    case fetchAllSuccessPlanTemplates.SUCCESS:
      return {
        ...state,
        successPlanTemplateCreateSuccess: true,
        successPlanTemplateListLoading: false,
        successPlanTemplateList: action.payload?.data || [],
      };
    case fetchAllSuccessPlanTemplates.FAILURE:
      return {
        ...state,
        successPlanTemplateCreateSuccess: false,
        successPlanTemplateListLoading: false,
      };

    case fetchSuccessPlanTemplateById.TRIGGER:
      return {
        ...state,
        selectedSuccessPlanTemplateSuccess: false,
        selectedSuccessPlanTemplateLoading: true,
        selectedSuccessPlanTemplate: null,
      };
    case fetchSuccessPlanTemplateById.SUCCESS:
      return {
        ...state,
        selectedSuccessPlanTemplateSuccess: true,
        selectedSuccessPlanTemplateLoading: false,
        selectedSuccessPlanTemplate: action.payload?.data || null,
      };
    case fetchSuccessPlanTemplateById.FAILURE:
      return {
        ...state,
        selectedSuccessPlanTemplateSuccess: false,
        selectedSuccessPlanTemplateLoading: false,
        selectedSuccessPlanTemplate: null,
      };

    case createSuccessPlanTemplate.TRIGGER:
      return {
        ...state,
        successPlanTemplateCreating: true,
        successPlanTemplateCreateSuccess: false,
      };
    case createSuccessPlanTemplate.SUCCESS:
      return {
        ...state,
        successPlanTemplateCreating: false,
        successPlanTemplateCreateSuccess: true,
      };
    case createSuccessPlanTemplate.FAILURE:
      return {
        ...state,
        successPlanTemplateCreating: false,
        successPlanTemplateCreateSuccess: false,
      };

    case updateSuccessPlanTemplate.TRIGGER:
      return {
        ...state,
        successPlanTemplateUpdating: true,
        successPlanTemplateUpdateSuccess: false,
      };
    case updateSuccessPlanTemplate.SUCCESS:
      return {
        ...state,
        successPlanTemplateUpdating: false,
        successPlanTemplateUpdateSuccess: true,
      };
    case updateSuccessPlanTemplate.FAILURE:
      return {
        ...state,
        successPlanTemplateUpdating: false,
        successPlanTemplateUpdateSuccess: false,
      };

    case archiveSuccessPlanTemplate.TRIGGER:
      return {
        ...state,
        successPlanTemplateArchiving: true,
        successPlanTemplateArchiveSuccess: false,
      };
    case archiveSuccessPlanTemplate.SUCCESS:
      return {
        ...state,
        successPlanTemplateArchiving: false,
        successPlanTemplateArchiveSuccess: true,
      };
    case archiveSuccessPlanTemplate.FAILURE:
      return {
        ...state,
        successPlanTemplateArchiving: false,
        successPlanTemplateArchiveSuccess: false,
      };
    default:
      return state;
  }
};

export default successPlanTemplateReducer;
